export default class Store {
  constructor () {
    this.token = ''
    this.admin = false
  }
  getToken () {
    return this.token
  }
  setToken (newToken) {
    this.token = newToken
  }
  getAdmin () {
    return this.admin
  }
  setAdmin (newAdmin) {
    this.admin = newAdmin
  }
}



// WEBPACK FOOTER //
// ./src/assets/Store.js